// lang.js
export default {
    data() {
      return {
        jp2cn: {},
      };
    },
    methods: {
      lang_after() {
          
      },
      push_hot_jp(v) {
        if (!this.jp2cn[v]) {
          this.jp2cn[v] = "";
        }
      },
      
      push_hot_highwaybus_jp(vo) {
        let jps = [];
        jps.push(vo.line);
        jps.push(vo.sn);
        jps.push(vo.start_tit);
        jps.push(vo.end_tit);
        for (let v of jps) {
          if (!this.jp2cn[v]) {
            this.jp2cn[v] = "";
          }
        }
      },
      push_hot_jbus(vo){
        let data = JSON.stringify(vo);
        vo = JSON.parse(data);
        console.log("push_hot_jbus",vo)
        let jps = [];
        let sn = vo.sn
        let line = vo.line
        console.log("push_hot_jbus",line)
        jps.push(sn);
        jps.push(line);
        
        // 添加防御性检查
        if (vo.starts && Array.isArray(vo.starts)) {
          for (let x of vo.starts) {
            let t = x.tit
            jps.push(t);
          }
        }
        
        if (vo.ends && Array.isArray(vo.ends)) {
          for (let x of vo.ends) {
            let t = x.tit
            jps.push(t);
          }
        }

        for (let v of jps) {
          if (!this.jp2cn[v]) {
            this.jp2cn[v] = "";
          }
        }
      },
      push_v4_sreach_jp(vo) {
        let jps = [];
        jps.push(vo.service_name);
        jps.push(...vo.tags.map((itm) => itm.display));
        jps.push(...vo.platforms.map((itm) => itm.name));
        for (let v of jps) {
          if (!this.jp2cn[v]) {
            this.jp2cn[v] = "";
          }
        }
      },
      push_v4_pre_jp(vo) {
        let jps = [];
        jps.push(vo.service_name);
        jps.push(...vo.tags.map((itm) => itm.display));
        jps.push(...vo.platforms.map((itm) => itm.name));
        for (let v of jps) {
          if (!this.jp2cn[v]) {
            this.jp2cn[v] = "";
          }
        }
      },
      get_cn() {
        console.log("get_cn", this.jp2cn);
        let jps = [];
        for (let k in this.jp2cn) {
          if (!this.jp2cn[k]) {
            jps.push(k);
          }
        }
        // 这里假设 this.get 是一个已经定义好的方法，用于发起 HTTP 请求
        // 如果没有定义，你需要根据实际情况实现这个方法
        // this.get("/v4/get_cn", {
        //   jps: jps,
        // }, "post").then((e) => {
        //   for (let jp in e.res) {
        //     this.jp2cn[jp] = e.res[jp];
        //   }
        
        //   this.lang_after()
        // });

        this.get("/v4/get_cn", {
          jps: jps,
        }, 'POST').then((e) => {
          for (let jp in e.res) {
            this.jp2cn[jp] = e.res[jp];
          }
        
          this.lang_after()
        });

      },
      tt(k) {
        if (this.cache("lang_config")!= "cn") {
          return k;
        }
        if (this.jp2cn[k]) {
          return this.jp2cn[k];
        }
        return k;
      },
    },
  };


// WEBPACK FOOTER //
// ./src/utils/lang.js